import { useState } from "react";
import {
  Card,
  CardContent,
  Divider,
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
  TextField,
  IconButton,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import Timeline from "@mui/lab/Timeline";
import moment from "moment";

import WalletInfo from "./Modules/WalletInfo";
// ** Icon Imports
import Icon from "src/@core/components/icon";
import { styled } from "@mui/material/styles";

import PdfViewer from "src/components/PdfViewer";

import Fields from "./Modules/Fields";

import SumTitle from "./Modules/SumTitle";

import ChangeIncomeRequisite from "./Modules/ChangeIncomeRequisite";

import { toast } from "react-hot-toast";

import OrderService from "src/service/Order";

import config from "src/configs/api";

export default function StepIncomingCounterParty({ disabledComponent, order }) {
  let [isSubmit, setIsSubmit] = useState("");
  let addedStyles = {};

  if (disabledComponent) {
    addedStyles = {
      "pointer-events": "none",
      cursor: "default",
      opacity: 0.32,
    };
  }

  let amount = order.amount;
  let takeCurrency = order.currency.take;

  let statusCode = order.status;

  // Handlers

  const isShowConfirmButton = order.CP_STATUS == "check_payment";
  const isPayment = statusCode == 102;

  // const
  // отобразить чек и реквизиты если есть

  const btns = <CardContent sx={{ p: 3 }}></CardContent>;

  return (
    <Card sx={{ bgcolor: (t) => t.palette.background.default, ...addedStyles }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <SumTitle text={"Сумма"} sum={amount.take} code={takeCurrency.code} />
        </Box>
      </CardContent>
      <Divider sx={{ my: "0px !important" }} />
      <CardContent sx={{ p: 3 }}>
        <Typography variant="body1">Реквизиты клиента:</Typography>

        <Fields list={order.fields.take} style={{ mt: 2 }} />
      </CardContent>

      <Divider sx={{ my: "0px !important" }} />

      {order.CP_STATUS == "wait_set_custom_requisite" && isPayment && (
        <FillRequisites order={order} />
      )}
      {order.CP_STATUS == "wait_payment" && isPayment && (
        <ShowRequisites order={order} />
      )}
      {(order.CP_STATUS == "check_payment" || !isPayment) && (
        <CheckPayment order={order} />
      )}
      <Divider sx={{ my: "0px !important" }} />
      <SelectPaymentDetails order={order} />
      <Divider sx={{ my: "0px !important" }} />
      {order.incomeInfo && (
        <CardContent sx={{ p: 3 }}>
          <Typography variant="body1">Реквизиты сервиса:</Typography>
          <Box sx={{ my: 3 }}>
            {order?.incomeInfo?.kitName && (
              <WalletInfo name="Комплект" value={order.incomeInfo.kitName} />
            )}
            {order?.incomeInfo?.requisiteName && (
              <WalletInfo
                name="Реквизит"
                value={order?.incomeInfo?.requisiteName}
              />
            )}
          </Box>

          <Fields isIncome list={order.fields.req} style={{ mt: 2 }} />
        </CardContent>
      )}

      <Box>
        <Divider sx={{ my: "0px !important" }} />
        <History order={order} />
      </Box>
    </Card>
  );
}

function SelectPaymentDetails({ order }) {
  let [isSubmit, setIsSubmit] = useState("");
  const [requisiteId, setRequisiteId] = useState(null);

  const serviceConfirmPayment = order.status == 104;
  const isShowConfirmButton = order.CP_STATUS == "check_payment";
  const isPayment = order.status == 102;

  const confirmIncomePaymentHandler = () => {
    if (!window.confirm("Подтвердить поступление средств?")) return;

    setIsSubmit("confirmIncome");
    OrderService.confirmIncome(order._id, { requisiteId })
      .then(() => {
        toast.success("Получение средств от клиента контрагенту подтверждено!");
      })
      .finally(() => {
        setIsSubmit("");
      });
  };

  const notIncomePaymentHandler = () => {
    if (!window.confirm("Не получение средств от клиента?")) return;

    setIsSubmit("notIncome");
    OrderService.notIncome(order._id)
      .then(() => {
        toast.success(
          "Не получение средств от клиента контрагенту подтверждено!"
        );
      })
      .finally(() => {
        setIsSubmit("");
      });
  };

  const cancelIncomePaymentHandler = () => {
    if (!window.confirm("Отменить поступление средств контрагенту?")) return;

    setIsSubmit("cancelIncome");
    OrderService.cancelIncome(order._id)
      .then(() => {
        toast.success("Поступление средств контрагенту отменено!");
      })
      .finally(() => {
        setIsSubmit("");
      });
  };

  const isShowConfirm = isPayment && isShowConfirmButton;

  return (
    <Box>
      {isShowConfirm && (
        <>
          {" "}
          <CardContent sx={{ p: 3 }}>
            <Typography variant="body1">
              Выберите реквизиты для зачисления:
            </Typography>
            <ChangeIncomeRequisite
              orderId={order._id}
              isCounterpartyReceive={true}
              sum={order.amount.take}
              currency={order?.currency?.take?.currency?._id}
              isCrypto={false}
              code="RUB"
              hideBtns
              setRequisiteId={setRequisiteId}
            />
          </CardContent>
          <Divider />
        </>
      )}

      <CardContent sx={{ p: 3 }}>
        <Grid container spacing={4}>
          {isShowConfirm && (
            <Grid item xs={6}>
              <Button
                fullWidth
                sx={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={confirmIncomePaymentHandler}
                disabled={isSubmit == "confirmIncome" || !requisiteId}
                startIcon={
                  isSubmit == "confirmIncome" ? <CircularProgress /> : null
                }
              >
                Подтвердить поступление
              </Button>
            </Grid>
          )}

          {isPayment && (
            <Grid item xs={6}>
              <Button
                fullWidth
                sx={{ fontSize: "0.8rem" }}
                variant="contained"
                color="error"
                onClick={notIncomePaymentHandler}
                disabled={isSubmit == "notIncome"}
                startIcon={
                  isSubmit == "notIncome" ? <CircularProgress /> : null
                }
              >
                Средства не поступили
              </Button>
            </Grid>
          )}

          {serviceConfirmPayment && (
            <Grid item xs={6}>
              <Button
                fullWidth
                sx={{ fontSize: "0.8rem" }}
                variant="contained"
                color="error"
                onClick={cancelIncomePaymentHandler}
                disabled={isSubmit == "cancelIncome"}
                startIcon={
                  isSubmit == "cancelIncome" ? <CircularProgress /> : null
                }
              >
                Отменить поступление
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Box>
  );
}

function History({ order }) {
  const [showHistory, setShowHistory] = useState(false);
  // CP_DATES
  // :
  // {wait_payment: "2025-05-28T14:50:32.428Z", payment: "2025-05-28T14:50:42.623Z"}
  const list = [
    {
      text: "Создание заявки",
      date: moment(order.createdAt).format("HH:mm:ss"),
    },
  ];

  const isShowHistory =
    Object.values(order.CP_DATES).filter(Boolean).length > 0;

  if (!isShowHistory) return null;

  if (order?.CP_DATES?.wait_payment) {
    const diffSeconds = moment(order.CP_DATES.wait_payment).diff(
      moment(order.createdAt),
      "seconds"
    );
    const minutesAndSeconds = moment.utc(diffSeconds * 1000).format("mm:ss");
    const added = [
      { date: minutesAndSeconds },
      {
        text: "Установлены реквизиты",
        date: moment(order.CP_DATES.wait_payment).format("HH:mm:ss"),
      },
    ];
    list.push(...added);
  }
  if (order?.CP_DATES?.payment) {
    const diffSeconds = moment(order.CP_DATES.payment).diff(
      moment(order.CP_DATES.wait_payment),
      "seconds"
    );
    const minutesAndSeconds = moment.utc(diffSeconds * 1000).format("mm:ss");
    const added = [
      { date: minutesAndSeconds },
      {
        text: "Оплата подтверждена",
        date: moment(order.CP_DATES.payment).format("HH:mm:ss"),
      },
    ];
    list.push(...added);
  }
  function renderHistory() {
    return (
      <Box className="flex justify-center items-center">
        <Timeline position="alternate-reverse" sx={{ overflowY: "auto" }}>
          {list.map((h, i) => {
            let isOdd = i % 2 == 0;
            return (
              <TimelineItem position={isOdd ? "left" : "right"}>
                <TimelineSeparator>
                  <TimelineDot color="primary" variant="outlined" />
                  {list.length == i + 1 ? null : <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  {isOdd ? (
                    <Box className="flex flex-col gap-2">
                      <Typography sx={{ fontSize: "0.7rem" }} variant="body2">
                        {h.text}
                      </Typography>
                      <Typography sx={{ fontSize: "0.8rem" }} variant="body1">
                        {h.date}
                      </Typography>
                    </Box>
                  ) : (
                    <Typography sx={{ fontSize: "0.8rem" }} variant="body1">
                      {h.date}
                    </Typography>
                  )}
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </Box>
    );
  }

  return (
    <CardContent sx={{ p: 3, py: "8px !important" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1">История</Typography>
        </Box>
        <IconButton onClick={() => setShowHistory(!showHistory)}>
          <Icon icon="material-symbols:expand-more-rounded" />
        </IconButton>
      </Box>
      <Collapse in={showHistory} timeout="auto" unmountOnExit>
        {renderHistory()}
      </Collapse>
    </CardContent>
  );
}
function FillRequisites({ order }) {
  const [phone, setPhone] = useState("");
  const [recipient, setRecipient] = useState("");
  const [bank, setBank] = useState("");
  const [submit, setSubmit] = useState("");

  const sendCounterpartyDataHandler = () => {
    if (!phone || !recipient || !bank) {
      toast.error("Заполните все поля для клиента!");
      return;
    }
    setSubmit("sendCounterpartyData");
    OrderService.sendCounterpartyData(order._id, {
      phone,
      recipient,
      bank,
    })
      .then((res) => {
        console.log(res);
        toast.success("Реквизиты установлены!");
      })
      .finally(() => {
        setSubmit("");
      });
  };
  return (
    <Box>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="body1">Заполните поля для клиента:</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            value={phone}
            label="Номер телефона для СБП перевода"
            onChange={(e) => setPhone(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
            size="small"
            type="text"
          />
          <TextField
            value={recipient}
            label="Получатель"
            onChange={(e) => setRecipient(e.target.value)}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
            type="text"
          />
          <TextField
            value={bank}
            label="Банк получателя"
            onChange={(e) => setBank(e.target.value)}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
            type="text"
          />

          <Button
            fullWidth
            sx={{ fontSize: "0.8rem" }}
            variant="contained"
            color="primary"
            onClick={sendCounterpartyDataHandler}
            disabled={submit == "sendCounterpartyData"}
            startIcon={
              submit == "sendCounterpartyData" ? <CircularProgress /> : null
            }
          >
            Отправить реквизиты
          </Button>
        </Box>
      </CardContent>
    </Box>
  );
}

function CheckPayment({ order }) {
  return (
    <Box>
      <CardContent sx={{ p: 3 }}>
        {order.CP_FIELDS?.length > 0 && (
          <>
            <Typography variant="body1">Реквизиты контрагента:</Typography>
            <Fields list={order.CP_FIELDS} />
          </>
        )}

        {order.CP_CHECK_PAYMENT && (
          <>
            <Typography variant="body1">Чек платежа:</Typography>
            <Box
              sx={{
                mx: 2,
                display: "flex",
                justifyContent: "center",
                width: "70%",
                margin: "0 auto",
              }}
            >
              <PdfViewer
                url={config.PRIVATE_PDF + order.CP_CHECK_PAYMENT}
                fileName={order.CP_CHECK_PAYMENT}
              />
            </Box>
          </>
        )}
      </CardContent>
    </Box>
  );
}

function ShowRequisites({ order }) {
  return (
    <Box>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="body1">Реквизиты контрагента:</Typography>

        <Fields list={order.CP_FIELDS} />

        {/* <Typography sx={{ mt: 2 }} variant="body2">
          Ожидание получение чека от клиента...
        </Typography> */}
      </CardContent>
    </Box>
  );
}
